var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHeartIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "head_btn_heart"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M12.5989 6.25268L12 6.84582L11.4011 6.25268C9.71459 4.58244 6.95351 4.58244 5.26486 6.25268C3.57838 7.92291 3.57838 10.6574 5.26486 12.3298L5.86378 12.9229L12 19L18.1362 12.9229L18.7351 12.3298C20.4216 10.6595 20.4216 7.92505 18.7351 6.25268C17.0486 4.58244 14.2876 4.58244 12.5989 6.25268Z",
    fill: "#CCCCCC",
    stroke: "#CCCCCC",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeartIcon);
export default __webpack_public_path__ + "static/media/heartIcon.1d7f607bb3d3e4e4b98285e2105eecc9.svg";
export { ForwardRef as ReactComponent };